import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import ProceduresContext from './ProceduresContext';
import CircularProgress from '@material-ui/core/CircularProgress';
import styled from 'styled-components';

const DialogTitleContainer = styled.div`
    width:100%
    display:flex;
    align-items:center;
    justify-content:space-between;
`;

export default function ConfirmArchiveDialog() {
  const context = React.useContext(ProceduresContext);
  const [saving, setSaving] = React.useState(false);


  if (!context.procedureToConfirmArchive) return null;

  return (

      <Dialog
        open={true}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
            <DialogTitleContainer>
            <div>Send to Archive</div>
            {saving && <CircularProgress size={20}/>}
            </DialogTitleContainer>
        </DialogTitle>
        <DialogContent>
         
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to send this procedure to the archive? You'll be able to view it, but you cannot return it to the active procedures list.
          </DialogContentText>
         
        </DialogContent>
        <DialogActions>
          <Button disabled={saving} onClick={()=>{context.confirmArchive(null);}} color="primary">
            CANCEL
          </Button>
          <Button  disabled={saving} onClick={()=>{
                setSaving(true)
                context.saveProcedure(context.procedureToConfirmArchive, success => {

                    setSaving(false)

                    if(success)
                    {
                        context.editProcedure(null);
                        context.confirmArchive(null)    
                    }
                });


          }} color="primary"
          
          autoFocus>
            ARCHIVE NOW
          </Button>
        </DialogActions>
      </Dialog>
  );
}